import i18n from "i18next";

import type { CellValue } from "../Table/types/types";
import type { TagVariant } from "../Tag/TagStyle";
import { TagStyle } from "../Tag/TagStyle";

interface CellColorBadgeProps {
    cellValue: CellValue;
}

const getCampaignStyleVariant = (cellValue: CellValue): TagVariant => {
    switch (cellValue) {
        case undefined:
        case null:
        case "UPDATED":
            return "heroGreen";
        case "GENERATING":
        case "WAITING":
            return "warning";
        case "STOPPED":
            return "darkGreen";
        case "FAILED":
            return "aeviRed";
        case "CREATED":
        default:
            return "lightPink";
    }
};

const getCampaignLabel = (cellValue: CellValue): string => {
    switch (cellValue) {
        case undefined:
        case null:
        case "CREATED":
            return i18n.t("enum.campaignState.created");
        case "GENERATING":
            return i18n.t("enum.campaignState.generating");
        case "WAITING":
            return i18n.t("enum.campaignState.waiting");
        case "UPDATED":
            return i18n.t("enum.campaignState.updated");
        case "STOPPED":
            return i18n.t("enum.campaignState.stopped");
        case "FAILED":
            return i18n.t("enum.campaignState.failed");
        default:
            return i18n.t("enum.status.active");
    }
};

export const HtmlCampaignStatusColorBadgeComponent = ({ cellValue }: CellColorBadgeProps) => {
    return <TagStyle $variant={getCampaignStyleVariant(cellValue)}>{getCampaignLabel(cellValue)}</TagStyle>;
};
